import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

// Selector de tipo de promoción + campos específicos (compartido por Productos y Paquetes)
export const PromoTypeFields = ({ formData, setFormData, products, selfId, selfName }) => (
  <>
            <div>
              <Label className="mb-2 block">Tipo de promoción</Label>
              <div className="grid grid-cols-3 gap-2">
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, promo_type: 'flat', promo_min_qty: '', promo_discount_percent: '', promo_qty_limit: '' })}
                  className={`p-2 border-2 rounded text-xs btn-transition text-center ${
                    formData.promo_type === 'flat' ? 'border-emerald-500 bg-emerald-50' : 'border-border hover:bg-slate-50'
                  }`}
                  data-testid="promo-type-flat"
                >
                  <div className="text-lg">🏷️</div>
                  <div className="font-semibold">Precio fijo</div>
                  <div className="text-[10px] text-muted-foreground leading-tight">Aplica siempre</div>
                </button>
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, promo_type: 'min_qty', promo_discount_percent: '', promo_qty_limit: '' })}
                  className={`p-2 border-2 rounded text-xs btn-transition text-center ${
                    formData.promo_type === 'min_qty' ? 'border-emerald-500 bg-emerald-50' : 'border-border hover:bg-slate-50'
                  }`}
                  data-testid="promo-type-min-qty"
                >
                  <div className="text-lg">📦</div>
                  <div className="font-semibold">Por volumen</div>
                  <div className="text-[10px] text-muted-foreground leading-tight">Cantidad mínima</div>
                </button>
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, promo_type: 'percent_discount', promo_min_qty: '', promo_price: '' })}
                  className={`p-2 border-2 rounded text-xs btn-transition text-center ${
                    formData.promo_type === 'percent_discount' ? 'border-cyan-500 bg-cyan-50' : 'border-border hover:bg-slate-50'
                  }`}
                  data-testid="promo-type-percent"
                >
                  <div className="text-lg">%</div>
                  <div className="font-semibold">Descuento %</div>
                  <div className="text-[10px] text-muted-foreground leading-tight">Rebaja porcentual</div>
                </button>
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, promo_type: 'limited_qty', promo_min_qty: '', promo_discount_percent: '' })}
                  className={`p-2 border-2 rounded text-xs btn-transition text-center ${
                    formData.promo_type === 'limited_qty' ? 'border-purple-500 bg-purple-50' : 'border-border hover:bg-slate-50'
                  }`}
                  data-testid="promo-type-limited"
                >
                  <div className="text-lg">🔢</div>
                  <div className="font-semibold">Cantidad limitada</div>
                  <div className="text-[10px] text-muted-foreground leading-tight">Cupo compartido</div>
                </button>
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, promo_type: 'gift', promo_min_qty: '', promo_discount_percent: '', promo_price: '', promo_qty_limit: '' })}
                  className={`p-2 border-2 rounded text-xs btn-transition text-center ${
                    formData.promo_type === 'gift' ? 'border-pink-500 bg-pink-50' : 'border-border hover:bg-slate-50'
                  }`}
                  data-testid="promo-type-gift"
                >
                  <div className="text-lg">🎁</div>
                  <div className="font-semibold">Regalo</div>
                  <div className="text-[10px] text-muted-foreground leading-tight">Compra A → B gratis</div>
                </button>
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, promo_type: 'free_shipping', promo_min_qty: '', promo_discount_percent: '', promo_price: '', promo_qty_limit: '', promo_local_only: false })}
                  className={`p-2 border-2 rounded text-xs btn-transition text-center ${
                    formData.promo_type === 'free_shipping' ? 'border-teal-500 bg-teal-50' : 'border-border hover:bg-slate-50'
                  }`}
                  data-testid="promo-type-free-shipping"
                >
                  <div className="text-lg">🚚</div>
                  <div className="font-semibold">Envío gratis</div>
                  <div className="text-[10px] text-muted-foreground leading-tight">No se cobra envío</div>
                </button>
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, promo_type: 'combo', promo_min_qty: '', promo_discount_percent: '', promo_price: '', promo_qty_limit: '' })}
                  className={`p-2 border-2 rounded text-xs btn-transition text-center ${
                    formData.promo_type === 'combo' ? 'border-orange-500 bg-orange-50' : 'border-border hover:bg-slate-50'
                  }`}
                  data-testid="promo-type-combo"
                >
                  <div className="text-lg">🔗</div>
                  <div className="font-semibold">Combo</div>
                  <div className="text-[10px] text-muted-foreground leading-tight">Con otro → $ menos</div>
                </button>
              </div>
            </div>

            {/* Campos según tipo */}
            {(formData.promo_type === 'flat' || formData.promo_type === 'min_qty' || formData.promo_type === 'limited_qty') && (
              <div>
                <Label htmlFor="promo_price">Precio en promoción ($)</Label>
                <Input
                  id="promo_price"
                  type="number"
                  step="0.01"
                  value={formData.promo_price}
                  onChange={(e) => setFormData({ ...formData, promo_price: e.target.value })}
                  data-testid="promo-price-input"
                  placeholder="Ej: 130.00"
                />
              </div>
            )}

            {formData.promo_type === 'min_qty' && (
              <div>
                <Label htmlFor="promo_min_qty">Cantidad mínima en carrito</Label>
                <Input
                  id="promo_min_qty"
                  type="number"
                  min="1"
                  value={formData.promo_min_qty}
                  onChange={(e) => setFormData({ ...formData, promo_min_qty: e.target.value })}
                  data-testid="promo-min-qty-input"
                  placeholder="Ej: 12"
                />
                <p className="text-xs text-muted-foreground mt-1">
                  Si el cliente lleva ≥ {formData.promo_min_qty || 'X'} piezas, aplica el precio promo automáticamente.
                </p>
              </div>
            )}

            {formData.promo_type === 'percent_discount' && (
              <div>
                <Label htmlFor="promo_percent">Descuento (%)</Label>
                <Input
                  id="promo_percent"
                  type="number"
                  min="1"
                  max="100"
                  step="1"
                  value={formData.promo_discount_percent}
                  onChange={(e) => setFormData({ ...formData, promo_discount_percent: e.target.value })}
                  data-testid="promo-percent-input"
                  placeholder="Ej: 20"
                />
                <p className="text-xs text-muted-foreground mt-1">Se resta este % sobre el precio del carrito.</p>
              </div>
            )}

            {formData.promo_type === 'limited_qty' && (
              <div>
                <Label htmlFor="promo_qty_limit">Cupo total (piezas)</Label>
                <Input
                  id="promo_qty_limit"
                  type="number"
                  min="1"
                  value={formData.promo_qty_limit}
                  onChange={(e) => setFormData({ ...formData, promo_qty_limit: e.target.value })}
                  data-testid="promo-qty-limit-input"
                  placeholder="Ej: 25"
                />
                <p className="text-xs text-muted-foreground mt-1">
                  Se comparte entre <b>Morelos</b> y <b>América</b>. Al llegar al límite, la promo se desactiva sola. Vendidas hasta ahora: <b>{formData.promo_qty_sold || 0}</b>.
                </p>
              </div>
            )}

            {formData.promo_type === 'gift' && (
              <>
                <div>
                  <Label htmlFor="promo_gift_product">Producto de regalo</Label>
                  <select
                    id="promo_gift_product"
                    value={formData.promo_gift_product_id || ''}
                    onChange={(e) => setFormData({ ...formData, promo_gift_product_id: e.target.value })}
                    className="w-full h-9 px-2 border border-slate-300 rounded-md text-sm"
                    data-testid="promo-gift-product"
                  >
                    <option value="">— Selecciona —</option>
                    {(products || [])
                      .filter(p => !p.has_variants && p.id !== selfId)
                      .map(p => (
                        <option key={p.id} value={p.id}>
                          {p.name}{p.variant_name ? ` (${p.variant_name})` : ''} · SKU {p.sku}
                        </option>
                      ))}
                  </select>
                  <p className="text-xs text-muted-foreground mt-1">
                    Cuando el cliente compre <b>{selfName || 'este producto'}</b>, el regalo se cobrará a $0 automáticamente.
                  </p>
                </div>
                <div>
                  <Label htmlFor="promo_gift_qty">Unidades de regalo por unidad del principal</Label>
                  <Input
                    id="promo_gift_qty"
                    type="number"
                    min="1"
                    value={formData.promo_gift_qty}
                    onChange={(e) => setFormData({ ...formData, promo_gift_qty: e.target.value })}
                    data-testid="promo-gift-qty"
                  />
                </div>
              </>
            )}

            {formData.promo_type === 'combo' && (
              <>
                <div>
                  <Label htmlFor="promo_combo_discount">Descuento fijo a {selfName || 'este producto'} ($)</Label>
                  <Input id="promo_combo_discount" type="number" step="0.01" min="0"
                    value={formData.promo_combo_discount ?? ''}
                    onChange={(e) => setFormData({ ...formData, promo_combo_discount: e.target.value })}
                    data-testid="promo-combo-discount" placeholder="Ej: 200" />
                </div>
                <div>
                  <Label htmlFor="promo_combo_product">Debe ir junto con</Label>
                  <select id="promo_combo_product" value={formData.promo_combo_product_id || ''}
                    onChange={(e) => setFormData({ ...formData, promo_combo_product_id: e.target.value })}
                    className="w-full h-9 px-2 border border-slate-300 rounded-md text-sm" data-testid="promo-combo-product">
                    <option value="">— Selecciona —</option>
                    {(products || []).filter(p => !p.has_variants && p.id !== selfId).map(p => (
                      <option key={p.id} value={p.id}>{p.is_package ? '📦 ' : ''}{p.name}{p.variant_name ? ` (${p.variant_name})` : ''}{p.sku ? ` · SKU ${p.sku}` : ''}</option>
                    ))}
                  </select>
                  <p className="text-xs text-muted-foreground mt-1">
                    Si en el carrito están los dos, a <b>{selfName || 'este producto'}</b> se le restan ${formData.promo_combo_discount || '?'}. Solo 1 pieza por venta; si se quita alguno vuelve a precio normal.
                  </p>
                </div>
              </>
            )}
  </>
);
